import { render, staticRenderFns } from "./IntegraWeb.vue?vue&type=template&id=622c48e6&scoped=true"
import script from "./IntegraWeb.vue?vue&type=script&lang=js"
export * from "./IntegraWeb.vue?vue&type=script&lang=js"
import style0 from "./IntegraWeb.vue?vue&type=style&index=0&id=622c48e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c48e6",
  null
  
)

export default component.exports